import * as React from "react";
import ProductList from "../tenant/ProductList";


export default function ProductsList() {

    const activeTenant = { _id: null, name: "TUTTI" };

    return (
        <ProductList
            showAll={true}
            activeTenant={activeTenant}
        />
    );

}
